import React from 'react';
import PropTypes from 'prop-types';
import { DataCard } from 'anf-core-react';

/**
 * PaymentIssueExplanation - Displays explanatory content for payment issues in WSS flow
 */
function PaymentIssueExplanation({ title, content }) {
  if (!title?.value && !content?.value) {
    return null;
  }

  return (
    <div className="payment-error-explaination-box">
      <DataCard variant="boxed" data-header="">
        <div className="data-card-header">
          <p className="h3">{title?.value || 'Why did this occur?'}</p>
        </div>
        <div className="data-card-content">
          {content?.value || 'This typically means there is a typo in either the credit card number or the expiration date, but you might also need to make sure your card has sufficient funds.'}
        </div>
      </DataCard>
    </div>
  );
}

PaymentIssueExplanation.propTypes = {
  title: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  content: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
};

PaymentIssueExplanation.defaultProps = {
  title: null,
  content: null,
};

export default PaymentIssueExplanation;
